module.exports = __webpack_public_path__ + "img/noaa-logo.85266ba6.png";